// extracted by mini-css-extract-plugin
export default {"DropdownMenu":"DropdownMenu_DropdownMenu__eFjRd","DropdownMenu__header":"DropdownMenu_DropdownMenu__header__4g1nJ","DropdownMenu__items":"DropdownMenu_DropdownMenu__items__kPx-a"};